import React from "react";
import { Link } from "react-router-dom";
import { Target, Sparkles, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div className="bg-[#05050A] text-white min-h-screen py-24 relative overflow-hidden" data-testid="about-page">
      
      {/* Background visual glow */}
      <div className="absolute top-20 left-1/4 w-[450px] h-[450px] bg-[#7C3AED]/5 rounded-full blur-[130px] pointer-events-none" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Header Section */}
        <div className="text-center space-y-4 mb-20">
          <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs font-semibold text-[#EA7C3D] tracking-wide">
            <Sparkles className="w-3.5 h-3.5 text-[#7C3AED]" />
            <span>Corporate Mission & Core Values</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black font-display tracking-tighter leading-none">About Aroveniq Solutions</h1>
          <p className="text-base sm:text-lg text-[#ABA3C2] max-w-2xl mx-auto leading-relaxed">
            Eliminating supplier risk and spend fragmentation with modern real-time automated data layers.
          </p>
        </div>

        {/* Corporate Mission Split */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
          <div className="space-y-6">
            <h2 className="text-2xl font-bold font-display tracking-tight text-white">Our Vision and Values</h2>
            <p className="text-sm text-[#ABA3C2] leading-relaxed font-body">
              Aroveniq was created under the fundamental belief that procurement operators and supply-chain directors deserve immediate, absolute transparency. Traditional audit spreadsheets are stagnant files that leave teams vulnerable to expensive disruption risks.
            </p>
            <p className="text-sm text-[#ABA3C2]/80 leading-relaxed font-body">
              We compile, scrub, and score thousands of distinct live vendor activity signals continuously to defend operating margins and reinforce regulatory SOC2 parameters safely.
            </p>
          </div>
          <div className="p-8 rounded-3xl bg-[#14101F]/80 border border-white/10 backdrop-blur-xl relative overflow-hidden flex flex-col justify-center space-y-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-tr from-[#4B2E83] to-[#7C3AED] flex items-center justify-center">
              <Target className="w-6 h-6 text-[#EA7C3D]" />
            </div>
            <h3 className="font-bold text-white text-base font-display">Sourcing Integrity Always</h3>
            <p className="text-xs text-[#ABA3C2] leading-normal font-body">
              Ensuring each active partner has undergone comprehensive kyc compliance, real-time insurance tracking, and ongoing delivery reviews.
            </p>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="p-10 sm:p-14 rounded-3xl bg-gradient-to-r from-[#4B2E83]/30 via-[#7C3AED]/20 to-[#EA7C3D]/20 border border-white/10 text-center space-y-6">
          <h2 className="text-2xl sm:text-3xl font-black font-display tracking-tighter">Ready to see Aroveniq in action?</h2>
          <p className="text-sm text-[#ABA3C2] max-w-xl mx-auto">
            Book a demo with our team and see how a unified vendor intelligence layer fits into your procurement workflow.
          </p>
          <Link
            to="/contact"
            data-testid="about-cta-book-demo"
            className="inline-flex items-center space-x-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#EA7C3D] hover:shadow-[0_0_20px_rgba(124,58,237,0.4)] text-white text-sm font-semibold tracking-wide transition-all"
          >
            <span>Book a Demo</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

      </div>
    </div>
  );
}